import logo from "../../Assets/images/protika.png";
import "./Header.scss";
import profile from "../../Assets/svg/profile- V2.svg";
import React, {useState, useEffect, useContext} from "react";
import {NavLink, Link, useNavigate} from "react-router-dom";
import ShopWidget from "../shopWidget/ShopWidget";
import axios from "axios";
import {SaleContext} from "../pages/Pages";
import {prefixUrl} from "../../Utils/utilsData";
import SidebarResponsive from "./SidebarResponsive";
import UseShowShopWidget from "../../hooks/ShowShopWidget";
import {useLocation} from "react-router";

const OrdibeheshtHeader = () => {
  const [loggedIn, setLoggedIn] = useState(false); // State to track login status
  const [userData, setUserData] = useState({
    name: "الناز",
    surname: "مهاجر",
  });
  const [showWidget, setShowWidget] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [list, setList] = useState([""]);
  const [showSearch, setShowSearch] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const saleNum = useContext(SaleContext);
  const [showShopBag, setShowShopBag] = useState("flex")
  const location = useLocation();

  const {setShowShopWidget, showShopWidget} = UseShowShopWidget();

  const name = localStorage.getItem("name");
  const token = localStorage.getItem("tokens");
  const items = [
    {link: "صفحه اصلی", path: "/", id: "main"},
    {link: "دسته بندی", path: "/Group", id: "group"},
    {link: " بلاگ", path: "/Blog", id: "blog"},
    {link: " درباره ما", path: "./AboutUs", id: "aboutUs"},
    {link: "تماس با ما", path: "./CallWithUs", id: "callWithUs"},
  ];

  const navigateTo = useNavigate();
  const [basketNum, setBasketNum] = useState("");

  const searchData = (value) => {
    if (value !== "") {
      setShowSearch(true);
      axios
        .get(`${prefixUrl()}/product/search.php?text=${value}`)
        .then((response) => {
          setSearchResult(response.data.output);
        });
    } else {
      setShowSearch(false);
    }
  };
  const changeHandler = (e) => {
    setSearchValue(e.target.value);
    searchData(e.target.value);
  };
  const calculate = (items) => {
    let sum = 0;
    let count = 0;
    for (let item of items) {
      sum += +item.count * +item.price;
      if (item.type === 2) {
        count += 1;
      } else {
        count += +item.count;
      }
      // setMainPrice(sum);
    }
    // setBasketNum(count);
  };
  useEffect(() => {
    let pros =
      localStorage.getItem("products") !== ""
        ? JSON.parse(localStorage.getItem("products"))
        : [];
    pros?.length === 0 ? setBasketNum(0) : setBasketNum(pros.length);
  }, [saleNum]);
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      searchData();
    }
  };
  const searchClickHandler = () => {
    if (searchValue !== "") {
      setShowSearch(false);

      navigateTo("/search", {
        state: {items: searchResult, word: searchValue},
      });
    }
  };
  const sideClasses = showSidebar ? "LinkHeader -sidebar" : "LinkHeader";
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (location.pathname === "/Basket") {
      setShowShopBag("none")
    } else {
      setShowShopBag("flex")
    }
  }, [location]);

  return (
    <header>
      <SidebarResponsive open={open} setOpen={setOpen}/>
      <div className="ColumnOrdibeheshtHeader">
        <div className="RowOrdibeheshtHeader">
          <Link to={"/"} className="LogoOrdibehesht">
            <img src={logo} alt=" پروتیکا"/>
          </Link>
          <div className="SearchHeader" onClick={() => setShowShopWidget(false)}>
            <div className="ImagesSearchHeader">
              <div className="imageSearchHeader" onClick={searchClickHandler}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 2C15.97 2 20 6.03 20 11C20 15.97 15.97 20 11 20C6.03 20 2 15.97 2 11C2 7.5 4 4.46 6.93 2.97"
                    stroke="#40B2AA"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.071 20.97C19.601 22.57 20.811 22.73 21.741 21.33C22.601 20.05 22.041 19 20.501 19C19.351 19 18.711 19.89 19.071 20.97Z"
                    stroke="#40B2AA"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div className="search-section">
              <input
                type="text"
                onChange={(e) => changeHandler(e)}
                value={searchValue}
                onKeyUp={handleKeyPress}
              />
              {showSearch && (
                <div className="searchbox-result">
                  <ul>
                    {searchResult.map((item) => {
                      return (
                        <Link
                          to={`/Group/product/${item.id}`}
                          onClick={() => setShowSearch(false)}
                        >
                          {item.title}
                        </Link>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="endOfHeader">
            <div className="shoppingBagHeader" style={{display:showShopBag}} onClick={() => {
              setShowShopWidget(!showShopWidget)
            }}>
              <div className="NumbershoppingBagHeader">
                <span>{basketNum}</span>
              </div>
              <button className="Khat">
                <svg
                  width="2"
                  height="19"
                  viewBox="0 0 2 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Vector 3"
                    d="M1 1V18"
                    stroke="#8D6650"
                    stroke-linecap="round"
                  />
                </svg>
              </button>
              <button className="imageshoppingBagHeader">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.4904 22.75H7.50042C5.78042 22.75 4.49043 22.29 3.69043 21.38C2.89043 20.47 2.58042 19.15 2.79042 17.44L3.69043 9.94C3.95043 7.73 4.51043 5.75 8.41043 5.75H15.6104C19.5004 5.75 20.0604 7.73 20.3304 9.94L21.2304 17.44C21.4304 19.15 21.1304 20.48 20.3304 21.38C19.5004 22.29 18.2204 22.75 16.4904 22.75ZM8.40042 7.25C5.52042 7.25 5.38042 8.38999 5.17042 10.11L4.27043 17.61C4.12043 18.88 4.30042 19.81 4.81042 20.38C5.32042 20.95 6.22042 21.24 7.50042 21.24H16.4904C17.7704 21.24 18.6704 20.95 19.1804 20.38C19.6904 19.81 19.8704 18.88 19.7204 17.61L18.8204 10.11C18.6104 8.37999 18.4804 7.25 15.5904 7.25H8.40042Z"
                    fill="#40B2AA"
                  />
                  <path
                    d="M16 8.75C15.59 8.75 15.25 8.41 15.25 8V4.5C15.25 3.42 14.58 2.75 13.5 2.75H10.5C9.42 2.75 8.75 3.42 8.75 4.5V8C8.75 8.41 8.41 8.75 8 8.75C7.59 8.75 7.25 8.41 7.25 8V4.5C7.25 2.59 8.59 1.25 10.5 1.25H13.5C15.41 1.25 16.75 2.59 16.75 4.5V8C16.75 8.41 16.41 8.75 16 8.75Z"
                    fill="#40B2AA"
                  />
                  <path
                    d="M20.41 17.78H8C7.59 17.78 7.25 17.44 7.25 17.03C7.25 16.62 7.59 16.28 8 16.28H20.41C20.82 16.28 21.16 16.62 21.16 17.03C21.16 17.44 20.82 17.78 20.41 17.78Z"
                    fill="#40B2AA"
                  />
                </svg>
              </button>
            </div>
            {showShopWidget && (
              <ShopWidget
                onShow={() => setShowShopWidget(false)}
                onGet={setBasketNum}
                list={list}
              />
            )}
            {loggedIn && userData ? (
              <div className="UserProfile">
                {/* Display user profile picture, name, surname */}
                <span className="nameAndLastName">
                  {userData.name} {userData.surname}
                </span>
                <img src={profile} alt="Profile Picture"/>
              </div>
            ) : (
              <div className="AccountHeader">
                <Link to={"/login"}>
                  {name && token ? name : "ورود | ثبت نام"}
                </Link>
              </div>
            )}
          </div>
        </div>
        <nav className={sideClasses}>
          <div className="close-header" onClick={() => setShowSidebar(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M13.9902 10.0099L14.8302 9.16992"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.16992 14.8301L11.9199 12.0801"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.8299 14.8299L9.16992 9.16992"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4 6C2.75 7.67 2 9.75 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C10.57 2 9.2 2.3 7.97 2.85"
                stroke="#EB455F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <ul className="headTabs_">
            {items.map((element, index) => {
              return (
                <li className="tab_" key={index + "items_"} id={element.id}>
                  <NavLink to={element.path}>{element.link}</NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      <div className="columnresponsive">
        <div className="RowOrdibeheshtHeader">
          <svg
            open={open} onClick={() => setOpen(!open)}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
              fill="#EE6900"
            />
            <path
              d="M21 12.75H3C2.59 12.75 2.25 12.41 2.25 12C2.25 11.59 2.59 11.25 3 11.25H21C21.41 11.25 21.75 11.59 21.75 12C21.75 12.41 21.41 12.75 21 12.75Z"
              fill="#EE6900"
            />
            <path
              d="M21 17.75H3C2.59 17.75 2.25 17.41 2.25 17C2.25 16.59 2.59 16.25 3 16.25H21C21.41 16.25 21.75 16.59 21.75 17C21.75 17.41 21.41 17.75 21 17.75Z"
              fill="#EE6900"
            />
          </svg>
          <div className="LogoOrdibehesht">
            <img src={logo} alt="اردیبهشت لوگو"/>
          </div>
          <div className="endOfHeader">
            {loggedIn && userData ? (
              <div className="UserProfile">
                {/* Display user profile picture, name, surname */}
                {/* <span className="nameAndLastName">{userData.name} {userData.surname}</span> */}
                <img src={profile} alt="Profile Picture"/>
              </div>
            ) : (
              <div className="AccountHeader">
                <button>
                  <Link to={"/login"}>
                    {name && token ? name : "ورود | ثبت نام"}
                  </Link>
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="rowSearchAndShoppingBag">
          <div className="SearchHeader">
            <div className="ImagesSearchHeader">
              <div className="imageSearchHeader">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 2C15.97 2 20 6.03 20 11C20 15.97 15.97 20 11 20C6.03 20 2 15.97 2 11C2 7.5 4 4.46 6.93 2.97"
                    stroke="#778D50"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.071 20.97C19.601 22.57 20.811 22.73 21.741 21.33C22.601 20.05 22.041 19 20.501 19C19.351 19 18.711 19.89 19.071 20.97Z"
                    stroke="#778D50"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="imageSwichSearchHeader">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="30" height="30" rx="15" fill="#ee6900"/>
                  <path
                    d="M23.3333 10.4167H18.3333"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.0001 10.4167H6.66675"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.2501 10.4167C16.2501 12.025 14.9417 13.3333 13.3334 13.3333C11.7251 13.3333 10.4167 12.025 10.4167 10.4167C10.4167 8.80833 11.7251 7.5 13.3334 7.5C13.6167 7.5 13.8917 7.54167 14.1501 7.61667"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M23.3333 19.5833H20"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.6667 19.5833H6.66675"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.6667 22.5C18.2775 22.5 19.5833 21.1942 19.5833 19.5833C19.5833 17.9725 18.2775 16.6667 16.6667 16.6667C15.0558 16.6667 13.75 17.9725 13.75 19.5833C13.75 21.1942 15.0558 22.5 16.6667 22.5Z"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <input
              type="text"
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
          </div>
          <div className="shoppingBagHeader" style={{display:showShopBag}}>
            <div className="NumbershoppingBagHeader">
              <span>{basketNum}</span>
            </div>
            <div className="Khat">
              <svg
                width="2"
                height="19"
                viewBox="0 0 2 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Vector 3"
                  d="M1 1V18"
                  stroke="#8D6650"
                  stroke-linecap="round"
                />
              </svg>
            </div>
            <div
              className="imageshoppingBagHeader"
              onClick={() => setShowShopWidget(!showShopWidget)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.4904 22.75H7.50042C5.78042 22.75 4.49043 22.29 3.69043 21.38C2.89043 20.47 2.58042 19.15 2.79042 17.44L3.69043 9.94C3.95043 7.73 4.51043 5.75 8.41043 5.75H15.6104C19.5004 5.75 20.0604 7.73 20.3304 9.94L21.2304 17.44C21.4304 19.15 21.1304 20.48 20.3304 21.38C19.5004 22.29 18.2204 22.75 16.4904 22.75ZM8.40042 7.25C5.52042 7.25 5.38042 8.38999 5.17042 10.11L4.27043 17.61C4.12043 18.88 4.30042 19.81 4.81042 20.38C5.32042 20.95 6.22042 21.24 7.50042 21.24H16.4904C17.7704 21.24 18.6704 20.95 19.1804 20.38C19.6904 19.81 19.8704 18.88 19.7204 17.61L18.8204 10.11C18.6104 8.37999 18.4804 7.25 15.5904 7.25H8.40042Z"
                  fill="#40B2AA"
                />
                <path
                  d="M16 8.75C15.59 8.75 15.25 8.41 15.25 8V4.5C15.25 3.42 14.58 2.75 13.5 2.75H10.5C9.42 2.75 8.75 3.42 8.75 4.5V8C8.75 8.41 8.41 8.75 8 8.75C7.59 8.75 7.25 8.41 7.25 8V4.5C7.25 2.59 8.59 1.25 10.5 1.25H13.5C15.41 1.25 16.75 2.59 16.75 4.5V8C16.75 8.41 16.41 8.75 16 8.75Z"
                  fill="#40B2AA"
                />
                <path
                  d="M20.41 17.78H8C7.59 17.78 7.25 17.44 7.25 17.03C7.25 16.62 7.59 16.28 8 16.28H20.41C20.82 16.28 21.16 16.62 21.16 17.03C21.16 17.44 20.82 17.78 20.41 17.78Z"
                  fill="#40B2AA"
                />
              </svg>
            </div>
            {showShopWidget && (
              <ShopWidget
                onShow={() => setShowWidget(false)}
                onGet={setBasketNum}
                list={list}
              />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default OrdibeheshtHeader;
